import * as React from "react";
import { IconImage } from "common/components/SerializedApp";
import { Icon } from "common/render/icon";

import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
import MoreMenu from "../../more-menu/more-menu";
import { CardGridRow } from "../../orgs-styles";

import { styled } from "sharedUI/styles";
import { ItemDescription } from "designer/lib/dropdown-types";

export const SubscriptionTileStyle = styled.div`
    position: relative;
`;

interface Props<T> {
    title: string;
    planName: string;
    planShortName: string;
    icon: IconImage;
    iconBackground: string;
    actionTitle: string;
    onChangePlan?: () => void;

    // menu props
    readonly menuItems?: readonly T[];
    readonly menuOnItemClick?: (item: T) => void;
    readonly menuDescriptionForItem?: (item: T) => ItemDescription;
}

export default class SubscriptionTile<T> extends React.PureComponent<Props<T>> {
    public render() {
        const {
            title,
            planName,
            icon,
            iconBackground,
            onChangePlan,
            menuItems,
            menuDescriptionForItem,
            menuOnItemClick,
            actionTitle,
        } = this.props;

        return (
            <SubscriptionTileStyle>
                <CardGridRow>
                    <div className="col-span-2 col-title">
                        <Icon image={icon} clipCorners={true} color={iconBackground} size={32} rounding={8} />
                        <div className="app-title">{title}</div>
                    </div>
                    <div>{planName}</div>
                    <div className="row-actions">
                        <ButtonVNext
                            onClick={onChangePlan}
                            buttonType={"minimal"}
                            variant={"accent"}
                            size={"md"}
                            label={actionTitle}
                        />

                        <div className="menu-container">
                            {menuItems !== undefined &&
                                menuDescriptionForItem !== undefined &&
                                menuOnItemClick !== undefined && (
                                    <MoreMenu
                                        items={menuItems}
                                        descriptionForItem={menuDescriptionForItem}
                                        onItemClick={menuOnItemClick}
                                    />
                                )}
                        </div>
                    </div>
                </CardGridRow>
            </SubscriptionTileStyle>
        );
    }
}
